/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePersonalTransportUnavailableReasonEnum =
  (typeof RoutePersonalTransportUnavailableReasonEnum)[keyof typeof RoutePersonalTransportUnavailableReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePersonalTransportUnavailableReasonEnum = {
  NoTransitFound: 0,
  BudgetExhausted: 1,
  LookupFailed: 2,
} as const;
